import { render, staticRenderFns } from "./ErroPergunta.vue?vue&type=template&id=58c9c034&scoped=true"
var script = {}
import style0 from "./ErroPergunta.vue?vue&type=style&index=0&id=58c9c034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9c034",
  null
  
)

export default component.exports